



















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  AcgnTaskNorDetail,
  AcgnAuditNorDetail,
  AcgnOverdueNorDetail,
  AcgnTargetDetail
} from './components';
import { Tabs, TabPane } from 'element-ui';

@Component({
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    AcgnTaskNorDetail,
    AcgnAuditNorDetail,
    AcgnOverdueNorDetail,
    AcgnTargetDetail
  }
})

/**
 * 项目明细-创作方
 */
export default class AcgnStatisticDetailNor extends Vue {

  @Prop({ default: true }) public isShowTarget: string; // 是否显示目标情况（项目才显示）
  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: false }) public isShowModify: boolean; // 显示修改按钮

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  // 1：管理方-总览 2：管理方-项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  private activeName: string = 'one';

  // 1：任务、2：过审、3：逾期、4：目标
  private tabs: any = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four'
  };

  private created() {
    const { type } = this.$route.params;
    this.activeName = this.tabs[type];
  }
}
